var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.currentLocale}},[(!_vm.containsSelectConstants)?_c('router-view'):_c('select-entity-wizard',{staticClass:"h-screen",attrs:{"entities":_vm.map}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }